// Wave AW.3-React (2026-05-16) — 외부 바이어 화면 공통 layout
// 헤더 (로고 + 로그아웃) + 가로 네비게이션 바 (탭) — 모든 /buyer/* 화면 재사용

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogoFull } from '../Logo';

var NAV_ITEMS = [
  { key: 'auctions',  label: '진행중 경매',     icon: '🔨', path: '/buyer/auctions',  enabled: true },
  { key: 'promise',   label: 'PROMISE 사전조회', icon: '📋', path: '/buyer/promise',   enabled: true },
  { key: 'bids',      label: '내 입찰',          icon: '🎯', path: '/buyer/bids',      enabled: true },
  { key: 'favorites', label: '즐겨찾기',         icon: '⭐', path: '/buyer/favorites', enabled: true },
];

function AuctionBuyerLayout(props) {
  var activeKey = props.activeKey;
  var children = props.children;
  var navigate = useNavigate();
  var buyer = (function(){ try { return JSON.parse(sessionStorage.getItem('autodex_buyer')||'null'); } catch(e) { return null; } })();

  var handleLogout = function() {
    localStorage.removeItem('autodex_buyer_token');
    localStorage.removeItem('autodex_buyer_refresh');
    sessionStorage.removeItem('autodex_buyer');
    navigate('/buyer/login');
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', fontFamily: "'Pretendard',sans-serif" }}>
      {/* 헤더 */}
      <div style={{
        background: 'white', borderBottom: '1px solid #e2e8f0',
        padding: '14px 32px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      }}>
        <div style={{ cursor: 'pointer' }} onClick={function(){navigate('/buyer/dashboard')}}>
          <LogoFull iconSize={28} fontSize={18} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          {buyer && (
            <span style={{ fontSize: 14, color: '#475569' }}>{buyer.name || buyer.email}</span>
          )}
          <button type="button" onClick={handleLogout}
            style={{
              padding: '8px 14px', background: 'white',
              border: '1.5px solid #e2e8f0', borderRadius: 8,
              fontSize: 13, fontWeight: 600, color: '#64748b',
              cursor: 'pointer', fontFamily: "'Pretendard',sans-serif",
            }}>
            로그아웃
          </button>
        </div>
      </div>

      {/* 네비게이션 바 */}
      <div style={{
        background: 'white', borderBottom: '1px solid #e2e8f0',
        padding: '0 32px',
        display: 'flex', alignItems: 'center', gap: 4,
        overflowX: 'auto',
      }}>
        {NAV_ITEMS.map(function(item) {
          var isActive = activeKey === item.key;
          var disabled = !item.enabled;
          return (
            <button key={item.key} type="button"
              onClick={function(){ if (item.enabled) navigate(item.path); }}
              disabled={disabled}
              style={{
                padding: '14px 18px', background: 'transparent',
                border: 'none',
                borderBottom: isActive ? '2.5px solid #1B3A5C' : '2.5px solid transparent',
                fontSize: 14, fontWeight: isActive ? 700 : 600,
                color: disabled ? '#94a3b8' : (isActive ? '#1B3A5C' : '#475569'),
                cursor: disabled ? 'not-allowed' : 'pointer',
                fontFamily: "'Pretendard',sans-serif",
                display: 'flex', alignItems: 'center', gap: 6,
                whiteSpace: 'nowrap',
                marginBottom: '-1px',
              }}>
              <span>{item.icon}</span>
              <span>{item.label}</span>
              {disabled && (
                <span style={{ fontSize: 10, fontWeight: 600, background: '#f1f5f9', color: '#94a3b8', padding: '2px 6px', borderRadius: 4, marginLeft: 4 }}>
                  준비중
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* 메인 컨텐츠 */}
      {children}
    </div>
  );
}

export default AuctionBuyerLayout;
